import { render, staticRenderFns } from "./smallerThan.vue?vue&type=template&id=0d7527af&"
import script from "./smallerThan.vue?vue&type=script&lang=ts&"
export * from "./smallerThan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports